import PAYROLL_CONSTANTS from "utils/constants/payroll";

const frequencyOptions = () =>
    Object.values(PAYROLL_CONSTANTS.PAYROLL_FREQUENCY).map((values) => ({
        value: values.id,
        label: values.description
    }));

const PAYROLL_HELPER = { frequencyOptions };
export default PAYROLL_HELPER;
